/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Simple Table Component
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.10.0
 */

import { CSSProperties, Fragment, ReactElement } from 'react';

import {
    SimpleTableCellStyled,
    SimpleTableHeaderRowStyled,
    SimpleTableRowStyled,
    SimpleTableStyled,
} from './styled/SimpleTableStyled';

export interface ISimpleTableColumns {
    align?: 'left' | 'center' | 'right' | 'justify' | 'char';
    id: string;
    flex?: number;
    hide?: boolean;
    style?: CSSProperties;
    title: string | ReactElement;
    width?: number;
}

export interface ISimpleTableData {
    id: string | number;

    [key: string]: string | number | ReactElement;
}

interface ISimpleTableProps {
    columns: ISimpleTableColumns[];
    data: ISimpleTableData[];
    dataTableName?: string;
    bordered?: boolean;
    maxHeight?: string;
}

const SimpleTable = (props: ISimpleTableProps) => {
    return <Fragment>

        <SimpleTableStyled bordered={props.bordered}
                           data-name={props?.dataTableName}
                           maxHeight={props.maxHeight}>
            <SimpleTableHeaderRowStyled>
                {
                    props.columns.filter(item => !item.hide).map((col: ISimpleTableColumns) =>
                        <SimpleTableCellStyled align={col?.align ?? 'left'}
                                               data-name={col.id}
                                               flex={col?.flex}
                                               key={col.id}
                                               width={col?.width}>
                            {col.title || ''}
                        </SimpleTableCellStyled>)
                }
            </SimpleTableHeaderRowStyled>
            {
                props.data.map((row: ISimpleTableData) => <SimpleTableRowStyled data-name={row.id} key={row.id}>
                    {
                        props.columns.filter(item => !item.hide).map((col: ISimpleTableColumns) =>
                            <SimpleTableCellStyled align={col?.align ?? 'left'}
                                                   data-name={col.id}
                                                   flex={col?.flex}
                                                   key={col.id}
                                                   style={col?.style}
                                                   width={col?.width}>
                                {row[col.id]}
                            </SimpleTableCellStyled>)
                    }
                </SimpleTableRowStyled>)
            }
        </SimpleTableStyled>

    </Fragment>;
};

export default SimpleTable;
